module.exports = __webpack_public_path__ + "static/GitLab-397dd580dff0b086a9b8c353d39c51b0.png";